import { render, staticRenderFns } from "./ifp-filter-due.vue?vue&type=template&id=3181f8cf&"
import script from "./ifp-filter-due.vue?vue&type=script&lang=ts&"
export * from "./ifp-filter-due.vue?vue&type=script&lang=ts&"
import style0 from "./ifp-filter-due.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports